import React from 'react'
import { createGlobalStyle } from 'styled-components';
import { Modal } from 'react-bootstrap';
import BaseBtn from '../common/styled/BaseBtn'
import WhiteBtn from '../common/styled/WhiteBtn'
import ModelBody from "../model/sub/ModelBody"
import BtnGroup from "../model/sub/BtnGroup"
import PropTypes from 'prop-types'

const GlobalStyle = createGlobalStyle`
  .supportSubjectModel {
    font-size: 20px;
    .modal-dialog {
      max-width: 980px;
    }
    .modal-header {
      flex-wrap: wrap;
    }
    .modal-title {
      color: #333;
      font-size: 20px;
    }
    .right-title {
      color: #3D6DE5;
      cursor: pointer;
      .fa {
        margin-left: 5px;
      }
    }
    .notice {
      color: #FF4540;
      text-align: center;
    }
  }
`

export default function SupportSubjectModel(props) {
  return (
    <>
      <GlobalStyle />
      <Modal show={props.show}
        className="supportSubjectModel"
        onHide={props.onHide}
      >
        <Modal.Header>
          <Modal.Title> 
            <a target="_blank" rel="noreferrer" href="https://docs.google.com/document/d/1LwBybMyd0nhEqy84U61VKPRd2HkvlnNxs8ze-hTRp_0/edit?usp=sharing">
              {/* How to grant TRIAS through personal wallet ? */}
              How to stake TRIAS from personal wallet ?
            </a>
          </Modal.Title>
          {/*<span className="right-title">Connect Wallet<i className="fa fa-arrow-right"></i></span>*/}
        </Modal.Header>
        <Modal.Body>
          {/* <p className="notice">
          *Users from Mainland China and the USA are restricted from participating in Trias Grant.
          </p> */}
          <ModelBody>Are you sure to become Trias Hunter?</ModelBody>
          <BtnGroup>
            <WhiteBtn width="240px" onClick={props.onHide} heigth="42px">Let me think again</WhiteBtn>
            <BaseBtn onClick={()=>{
              props.onHide()
              props.toSupport()
            }} width="240px" heigth="42px">Yes, start to stake 50 TRIAS.</BaseBtn>
          </BtnGroup>
        </Modal.Body>
      </Modal>
    </>
  )
}

SupportSubjectModel.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  toSupport: PropTypes.func.isRequired,
}
